import React, { useEffect } from "react";
import AOS from "aos";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import "../../assests/css/CustomIamgeSection.css";

const CustomIamgeSection = (props) => {
	useEffect(() => {
		setTimeout(() => {
			AOS.init();
		}, 1000);
	}, []);

	console.log(props);
	return (
		<div
			style={{ backgroundImage: `url("${props.content.image}")` }}
			className="CustomIamgeSection"
		>
			<div className="container-fluid">
				<div className="custom_main_layout">
					<div className="">
						<p data-aos="fade-left" className="font_heading">
							{" "}
							{props.content.heading_one}
						</p>
						<p data-aos="fade-right" className="font_heading">
							{" "}
							{props.content.heading_two}
						</p>
						<div data-aos="fade-left" className="brdr-btm-white"></div>
					</div>
					<div className="row">
						<div className="col-lg-7 ">
							<p data-aos="fade-right" className="font_p">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
								eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
								enim ad minim veniam.
							</p>
							<p data-aos="fade-left" className="mt-5 font_learn_more">
								Learn More <ArrowRightAltIcon className="ml-3" />
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CustomIamgeSection;
